// extracted by mini-css-extract-plugin
module.exports = {"detail":"pit-detail_detail_2rGrv","listWrap":"pit-detail_listWrap_kjNH5"};